import React from "react";
import EnglishFlag from "../../../../images/flags/english-sq.png";
import { DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { LangDropdown, UserAvatar } from "../../../../components/Component";
import { useSelector } from "react-redux";

const LanguageHead = () => {
  const { data, loading, error } = useSelector((state) => state.currentUser);
  const logoUrl = (orgLogo) => {
    try {
      if (typeof orgLogo === "string") {
        return orgLogo;
      } else {
        return orgLogo[0];
      }
    } catch (error) {}
  };
  return (
    <UncontrolledDropdown
      className="language-dropdown"
      style={{ display: "flex", alignItems: "center", height: "100%" }}
    >
      <img
        src={logoUrl(data?.orgLogo)}
        alt={""}
        style={{
          height: 64,
          maxWidth: 220,
          width: "auto",
          objectFit: "contain",
          objectPosition: "center",
          display: "block",
          marginTop: -14,
          marginBottom: -14,
        }}
      />
      {/* <DropdownToggle
        tag="a"
        href="#toggle"
        onClick={(ev) => ev.preventDefault()}
        className="dropdown-toggle nk-quick-nav-icon"
      >
        </DropdownToggle> */}
        {/* <UserAvatar className="border border-light xs" theme={"light"}>
          <img src={logoUrl(data?.orgLogo)} alt="" />
        </UserAvatar> */}
      {/* <LangDropdown className="dropdown-menu-s1" /> */}
    </UncontrolledDropdown>
  );
};

export default LanguageHead;
